import React from 'react';
import { CheckCircle, CreditCard } from 'lucide-react';

interface SuccessViewProps {
  onNewSale: () => void;
  deliveryMethod?: string;
}

function SuccessView({ onNewSale, deliveryMethod }: SuccessViewProps) {
  const isPaidOnSpot = deliveryMethod === 'En el lugar';
  const paymentStatus = isPaidOnSpot ? 'Pagado' : 'Por pagar';
  const paymentMessage = isPaidOnSpot 
    ? 'Pago realizado al momento de la venta.' 
    : 'Estado de pago: Por pagar';

  return (
    <div className="success-view">
      <div className="success-content">
        <div className="success-icon">
          <CheckCircle size={48} color="#4caf50" />
        </div>
        <h1>¡Pedido Confirmado!</h1>
        <p>Tu pedido ha sido procesado exitosamente.</p>
        <p>{paymentMessage}</p>
        <p>Recibirás una confirmación por email.</p>
        
        <div className="success-actions">
          <button className="btn-primary" onClick={onNewSale}>
            Nueva Venta
          </button>
        </div>
      </div>
    </div>
  );
}

export default SuccessView; 